import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetIncidentTypeModel } from "@core/model/query-model-incident-type";
import { incidentTypeFormDefault } from "./form.default";
import { IncidentTypeFormSchema } from "./form.rule";

export const useFormDefaultIncidentType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetIncidentTypeModel | undefined) => {
    return !cachedValue
      ? incidentTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as IncidentTypeFormSchema);
  };

  return {
    getDefault,
  };
};
